import { Component, OnInit } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DtoModule, DtoSubCategory, DtoPackage, DtoPackageModule, DtoPreviewItem } from '../../../models/package-center.model';
import { ToastrService } from 'ngx-toastr';
import { PackageService } from '../../package-center/package/package.service';
import { SchoolService } from '../school.service';
import { Role } from '../../../models/role.model';
import { ProdetailsModalComponent } from '../../data-management/prodetails-modal/prodetails-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { SharedService } from '../../../shared/services/shared.service';

@Component({
  selector: 'app-request-access',
  templateUrl: './request-access.component.html'
})
export class RequestAccessComponent implements OnInit {
  
  packageId: number = 0;
  availableGroupedSubCategories: { [key: string]: DtoSubCategory[] } = {};
  groupedSubCategories: { [key: string]: DtoSubCategory[] } = {};
  packageForm = new FormGroup({
    role: new FormControl(null as number | null, Validators.required),
    modules: new FormControl([] as DtoModule[], [
      Validators.required
    ]),
    subCategories: new FormControl([] as DtoSubCategory[], [
      Validators.required
    ])
  });

  preSelectedModules: DtoModule[] = [];
  preSelectedSubCategories: DtoSubCategory[] = [];
  subCategories: DtoSubCategory[] = [];
  modules: DtoModule[] = [];
  package: DtoPackage = {} as DtoPackage;
  newlySelectedModules: DtoModule[] = [];
  newlySelectedSubCategories: DtoSubCategory[] = [];
  roleData = {} as Role;
  roles: Role[] = [];
  isReadOnly: boolean = true;
  
  constructor(
    private toasterService: ToastrService,
    private packageService: PackageService,
    public schoolService: SchoolService,
    private dialog: MatDialog,
    public sharedService: SharedService
  ){ }

  ngOnInit(): void {
    this.packageId = Number(sessionStorage.getItem('packageId'));
    this.getRoleList();

    this.isReadOnly=true;
    this.schoolService.checkIfAnyActiveAccessRequestExists(sessionStorage.getItem('user_email')!).subscribe((response: boolean | any)=>{
      if(response) {
        this.toasterService.warning("An active request to add some Module & Analytics Toolkit already exists");
      }
      else{
        this.isReadOnly=false;
      }
      
    },(err: HttpErrorResponse)=>{
      if(err.error){
        this.toasterService.error(err.error, "Error");
      }
    })
  }

  _createGroupedValues(subCategories: DtoSubCategory[]){
    return (subCategories??[]).reduce((result, sc) => 
            {
              const key = sc.moduleDisplayName!;
              result[key] = result[key] || [];
              result[key].push(sc);
              return result;
            },{} as {[key:string]: DtoSubCategory[]});
  }

  getRoleList(){
    let role: any = sessionStorage.getItem('user_role')?.split(',').map(Number);
    this.schoolService.getRoleList(role).subscribe((response: Role[] | any) =>{
      this.roles = response;
      this.roleData = response[0];
      if(this.roleData){
        this.packageForm.controls['role'].setValue(this.roleData.roleId);
        this.getPackageByPackageId(this.packageId);
      }
    })
  }

  onSelectingRole(selectedValue: number){
    let role = this.roles.find(x=>x.roleId == selectedValue)!;
    this.packageForm.controls['role'].setValue(role.roleId);
    this.roleData = role;
    this.getPackageByPackageId(this.packageId);
  }

  getPackageByPackageId(assignedPackageId: number) {
    this.packageService.getPackageByPackageId(assignedPackageId).subscribe((response: DtoPackage[] | any)=>{
      this.package = response[0];
      this.modules = this.package.modules.map((x: DtoPackageModule)=>{
        return{
          moduleId: x.moduleId,
          moduleName: x.moduleName
        } as DtoModule
      })
      this.preSelectedModules = this.modules.filter((module: DtoModule) => {
        return this.roleData.modules.some((packageModule: DtoModule) => module.moduleId === packageModule.moduleId);
      });
      this.packageForm.controls['modules'].setValue(this.preSelectedModules);
      let payload = this.roleData.modules.map((x: DtoModule) => ({
        moduleId: x.moduleId,
        moduleName: x.moduleName
      }))
      this.packageService.getSubCategoriesOfPackage(payload, this.packageId).subscribe((response: DtoSubCategory[] | any) => {
        this.subCategories = response
        this.preSelectedSubCategories = this.subCategories.filter((subCategory: DtoSubCategory) => {
          return this.roleData.subCategories.some((packagesubCategory: DtoSubCategory) => subCategory.subCategoryId === packagesubCategory.subCategoryId);
        });
        this.packageForm.controls['subCategories'].setValue(this.preSelectedSubCategories);

        this.availableGroupedSubCategories = this._createGroupedValues(this.subCategories);
        this.groupedSubCategories = this._createGroupedValues(this.preSelectedSubCategories);
      },(err: HttpErrorResponse)=>{
        if(err.error){
          this.toasterService.error(err.error, "Error");
        }
      })
    },(err: HttpErrorResponse)=>{
      if(err.error){
        this.toasterService.error(err.error, "Error");
      }
    });
  }

  isAlreadySelected(value: any, isModule: boolean): boolean {
    if(isModule){
      return this.preSelectedModules.includes(value);
    }
    else{
      return this.preSelectedSubCategories.some((preSelected: any) => preSelected.subCategoryId === value.subCategoryId);
    }
  }

  onSubCategoryChange(selectedSubCategory: any){
    let subCategory = selectedSubCategory.value;

    let newlySelectedValues = subCategory.filter(
      (value: DtoSubCategory) => !this.preSelectedSubCategories.includes(value)
    );

    this.newlySelectedSubCategories = newlySelectedValues;
  }

  onModuleChange(selectedModule: any){
    let module = selectedModule.value;

    let newlySelectedValues = module.filter(
      (value: DtoModule) => !this.preSelectedModules.includes(value)
    );
    this.newlySelectedModules = newlySelectedValues;

    this.packageService.getSubCategoriesOfPackage(module, this.packageId).subscribe((response: DtoSubCategory[] | any) => {
      this.subCategories = response;
      let subCategories = this.subCategories.filter((subCategory: DtoSubCategory) => {
        return this.packageForm.controls['subCategories'].value?.some((packagesubCategory: DtoSubCategory) => subCategory.subCategoryId === packagesubCategory.subCategoryId);
      });
      this.packageForm.controls['subCategories'].setValue(subCategories);

      this.availableGroupedSubCategories = this._createGroupedValues(this.subCategories);
      this.groupedSubCategories = this._createGroupedValues(subCategories);
    },(err: HttpErrorResponse)=>{
      if(err.error){
        this.toasterService.error(err.error, "Error");
      }
    })
  }

  removeSubCategory(subCategoryToRemove: DtoSubCategory){
    let subCategories = this.packageForm.controls['subCategories'].value!.filter((x: DtoSubCategory)=>x.subCategoryId != subCategoryToRemove.subCategoryId);
    this.packageForm.controls['subCategories'].setValue(subCategories);

    //this.availableGroupedSubCategories = this._createGroupedValues(this.subCategories);
    this.groupedSubCategories = this._createGroupedValues(subCategories);
  }

  removeModule(moduleToRemove: DtoModule){
    let modules = this.packageForm.controls['modules'].value!.filter((x: DtoModule)=>x.moduleId != moduleToRemove.moduleId);
    this.packageForm.controls['modules'].setValue(modules);
    this.onModuleChange({value: this.packageForm.controls['modules'].value});
  }

  previewPopup(title: string, type: string){
    this.dialog.open(ProdetailsModalComponent,{
      width: '1000px',
      panelClass: 'modal-prodetails',
      data: {
        singleItemPreview: !!title,
        packageDetails: {},
        itemToPreview: type == 'Module' ? (this.packageForm.controls['modules'].value!.map((x: DtoModule)=>({
          groupName: null,
          itemName:x.moduleName})) as DtoPreviewItem[]):
                                          (this.packageForm.controls['subCategories'].value!.map((x: DtoSubCategory)=>({
                                            groupName: x.moduleDisplayName,
                                            itemName: x.subCategoryName}))  as DtoPreviewItem[]),
        title: title
      }
    })
  }

  requestAccess(){
    // if(this.newlySelectedModules.length == 0){
    //   this.toasterService.warning('Please select some Modules to request access');
    //   return;
    //}
    if(this.newlySelectedSubCategories.length == 0){
      this.toasterService.warning('Please select some Analytics Toolkits to request access');
      return;
    }

    let excludedSubCategories: DtoSubCategory[] = this.newlySelectedSubCategories.filter(
      subCategory => !this.preSelectedSubCategories.some(
        preSelected => preSelected.subCategoryId === subCategory.subCategoryId
      )
    );

    let roleDetails: Role = {
      roleId : this.roleData.roleId,
      roleName: this.roleData.roleName,
      isIndividualEntity: this.roleData.isIndividualEntity,
      individualSchoolId: this.roleData.clientAccountId,
      clientAccountId: this.roleData.clientAccountId,
      requestedRole: true,
      modules: this.packageForm.controls['modules'].value,
      subCategories: this.packageForm.controls['subCategories'].value,
      newlySelectedModules: this.newlySelectedModules,
      newlySelectedSubCategories: excludedSubCategories
    } as Role;

    this.schoolService.requestAccessToViewReport(roleDetails).subscribe((response: any)=>{
      if(response){
        this.toasterService.success("Request to access module(s) and subcategory(s) sent successfully", "Success");
        this.sharedService.loadReportCheck(true);
      }
    },(err: HttpErrorResponse)=>{
      if(err.error){
        this.toasterService.error(err.error, "Error");
      }
    })
  }
}
